import { ParsedQs } from "qs";

type AppliedFilters = Record<string, string | string[] | undefined>;

interface FilterValues {
  selectedCategories: string[] | null;
  selectedFulfillments: string[] | null;
}

export const extractFilterValues = (parsedQs: ParsedQs): FilterValues => {
  const appliedFilters = getAppliedFilters(parsedQs);

  const selectedCategories = appliedFilters.category
    ? Array.isArray(appliedFilters.category)
      ? (appliedFilters.category as string[])
      : [appliedFilters.category]
    : null;

  const selectedFulfillments = parsedQs.fulfillment
    ? Array.isArray(parsedQs.fulfillment)
      ? (parsedQs.fulfillment as string[])
      : [parsedQs.fulfillment as string]
    : null;

  return {
    selectedCategories,
    selectedFulfillments,
  };
};

export const appliedFilterSections = (parsedQs: ParsedQs): string[] => {
  const appliedFilters = getAppliedFilters(parsedQs);
  return Object.keys(appliedFilters);
};

const getAppliedFilters = (parsedQs: ParsedQs): AppliedFilters => {
  return (parsedQs.filter as AppliedFilters) || {};
};
